import React from "react";

export default function LamansSin() {
  return (
    <>
      <h3>
        Laman's Sin is a song about the heart break and anger felt by the Aiel
        people when they learned that Laman cut down the Chora tree they gifted
        his people to make a throne for himself.
      </h3>
      <p class="c2">
        <span>
          <p>Beneath the sun, the sapling grew,</p>
          <p>Its leaves of peace, its branches true.</p>
          <p>A gift of life, from desert hands,</p>
          <p>It graced the heart of Cairhien’s lands.</p>
        </span>
      </p>
      <p class="c2">
        <span>
          <p>But pride took root, and honor died,</p>
          <p>A tree cut down, a trust denied.</p>
        </span>
      </p>
      <p class="c2">
        <span>
          <p>Laman’s pride, Laman’s sin,</p>
          <p>The shadow rose where light had been.</p>
          <p>Oathbreakers all, the treekillers stand,</p>
          <p>We march with vengeance across the land.</p>
        </span>
      </p>
      <p class="c2">
        <span>
          <p>We gave them water, we gave them peace,</p>
          <p>A bond of trust that would never cease.</p>
          <p>But for a throne, he stole the life,</p>
          <p>And carved his sin with a butcher’s knife.</p>
        </span>
      </p>
      <p class="c2">
        <span>
          <p>The Tree of Life, its spirit torn,</p>
          <p>Left us betrayed, our hearts forlorn.</p>
        </span>
      </p>
      <p class="c2">
        <span>
          <p>Laman’s pride, Laman’s sin,</p>
          <p>The shadow rose where light had been.</p>
          <p>Oathbreakers all, the treekillers stand,</p>
          <p>We march with vengeance across the land.</p>
        </span>
      </p>
      <p class="c2">
        <span>
          <p>The sands we cross, the veils we wear,</p>
          <p>For honor lost, for blood to bear.</p>
          <p>The Chora’s leaves will fall no more,</p>
          <p>Its memory burns at our very core.</p>
        </span>
      </p>
      <p class="c2">
        <span>
          <p>A song of peace turned into a wail,</p>
          <p>The Tree of Life left to the tale.</p>
          <p>The Aiel rise, our hearts ablaze,</p>
          <p>To end the sin of Laman’s ways.</p>
        </span>
      </p>
      <p class="c2">
        <span>
          <p>Laman’s pride, Laman’s sin,</p>
          <p>The shadow rose where light had been.</p>
          <p>Oathbreakers all, the treekillers stand,</p>
          <p>We march with vengeance across the land.</p>
        </span>
      </p>
      <p class="c2">
        <span>
          <p>A gift betrayed, a trust undone,</p>
          <p>The treekillers’ shame cannot be spun.</p>
          <p>For every leaf that never grew,</p>
          <p>The Aiel’s wrath will see it through.</p>
        </span>
      </p>
    </>
  );
}
